// src/components/SpecialPackages/SpecialPackages.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import './SpecialPackages.css';

interface Package {
  title: string;
  description: string;
  originalPrice: string;
  discountedPrice: string;
  savings: string;
}

const SpecialPackages: React.FC = () => {
  const packages: Package[] = [
    {
      title: 'Complete Life Reading',
      description: 'Birth Chart + Career Guidance + Monthly Forecast',
      originalPrice: '$205',
      discountedPrice: '$175',
      savings: '$30'
    },
    {
      title: 'Relationship Bundle',
      description: 'Love Compatibility + Individual Birth Charts (2)',
      originalPrice: '$245',
      discountedPrice: '$199',
      savings: '$46'
    }
  ];

  return (
    <section className="packages-section">
      <div className="container">
        <h2>Special Packages</h2>
        <div className="packages-grid">
          {packages.map((pkg, index) => (
            <div key={index} className="package-card">
              <h3>{pkg.title}</h3>
              <p>{pkg.description}</p>
              <div className="package-price">
                <span className="original-price">{pkg.originalPrice}</span>
                <span className="discounted-price">{pkg.discountedPrice}</span>
              </div>
              <Link to="/submit-details" className="package-button">
                Save {pkg.savings}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SpecialPackages;